<template>
    <div id="products-page">
        <AppHero
            :heading="'Our Products'"
        />

        <OurProducts />
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import OurProducts from "@/views/OurProducts/OurProducts";

    export default {
        name: 'OurProductsPage',
        metaInfo: {
            title: 'Khonsu - Our Products'
        },
        components: {
            AppHero,
            OurProducts,
        }
    }
</script>